"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "BaseContract", {
  enumerable: true,
  get: function () {
    return _contracts.BaseContract;
  }
});
Object.defineProperty(exports, "BigNumber", {
  enumerable: true,
  get: function () {
    return _bignumber.BigNumber;
  }
});
Object.defineProperty(exports, "Contract", {
  enumerable: true,
  get: function () {
    return _contracts.Contract;
  }
});
Object.defineProperty(exports, "ContractFactory", {
  enumerable: true,
  get: function () {
    return _contracts.ContractFactory;
  }
});
Object.defineProperty(exports, "FixedNumber", {
  enumerable: true,
  get: function () {
    return _bignumber.FixedNumber;
  }
});
Object.defineProperty(exports, "Signer", {
  enumerable: true,
  get: function () {
    return _abstractSigner.Signer;
  }
});
Object.defineProperty(exports, "VoidSigner", {
  enumerable: true,
  get: function () {
    return _abstractSigner.VoidSigner;
  }
});
Object.defineProperty(exports, "Wallet", {
  enumerable: true,
  get: function () {
    return _wallet.Wallet;
  }
});
Object.defineProperty(exports, "Wordlist", {
  enumerable: true,
  get: function () {
    return _wordlists.Wordlist;
  }
});
exports.constants = void 0;
Object.defineProperty(exports, "errors", {
  enumerable: true,
  get: function () {
    return _logger.ErrorCode;
  }
});
Object.defineProperty(exports, "getDefaultProvider", {
  enumerable: true,
  get: function () {
    return providers.getDefaultProvider;
  }
});
exports.utils = exports.providers = exports.logger = void 0;
Object.defineProperty(exports, "version", {
  enumerable: true,
  get: function () {
    return _version.version;
  }
});
Object.defineProperty(exports, "wordlists", {
  enumerable: true,
  get: function () {
    return _wordlists.wordlists;
  }
});

var _contracts = require("@ethersproject/contracts");

var _bignumber = require("@ethersproject/bignumber");

var _abstractSigner = require("@ethersproject/abstract-signer");

var _wallet = require("@ethersproject/wallet");

var constants = _interopRequireWildcard(require("@ethersproject/constants"));

exports.constants = constants;

var providers = _interopRequireWildcard(require("@ethersproject/providers"));

exports.providers = providers;

var _wordlists = require("@ethersproject/wordlists");

var utils = _interopRequireWildcard(require("./utils"));

exports.utils = utils;

var _logger = require("@ethersproject/logger");

var _version = require("./_version");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

////////////////////////
// Compile-Time Constants
// This is generated by "npm run dist"
const logger = new _logger.Logger(_version.version); ////////////////////////
// Exports

exports.logger = logger;